import React from 'react';
import { motion } from 'framer-motion';
export function Timeline() {
  const steps = [{
    badge: 'SEMANA 1',
    color: 'text-brand-cyan border-brand-cyan bg-brand-cyan/10',
    dot: 'bg-brand-cyan',
    title: 'El Gran Reseteo (Desinflamación)',
    desc: 'Eliminar aceites industriales, implementar ayuno 14:10 → 16:8, electrolitos matutinos, magnesio nocturno, protocolo cero pantallas. Resultados: crash de 3 PM eliminado.'
  }, {
    badge: 'SEMANA 2',
    color: 'text-brand-purple border-brand-purple bg-brand-purple/10',
    dot: 'bg-brand-purple',
    title: 'Encendido Metabólico y Fuerza Celular',
    desc: 'Primera ducha fría, HIIT de 20 min, bloques de enfoque 90 min, exposición solar matutina, alimentos fermentados. Resultados: 2-3 kg menos de inflamación.'
  }, {
    badge: 'SEMANA 3',
    color: 'text-blue-400 border-blue-400 bg-blue-400/10',
    dot: 'bg-blue-400',
    title: 'Optimización Hormonal y Cognitiva',
    desc: 'Omega-3 premium, D3+K2, ayuno de dopamina 4h, terapia de calor, Box Breathing. Resultados: claridad mental notable, tus colegas empiezan a preguntar qué hiciste.'
  }, {
    badge: 'SEMANA 4',
    color: 'text-brand-gold border-brand-gold bg-brand-gold/10',
    dot: 'bg-brand-gold',
    title: 'Consolidación del Nuevo Hardware',
    desc: 'Ducha fría 3 min, Deep Work 3 horas, ayuno como identidad, auditoría de fotones, socialización estratégica. Resultados: alto rendimiento como estado automático.'
  }];
  return <section className="py-24 px-6 bg-brand-bg-alt" data-id="element-721">
      <div className="max-w-[800px] mx-auto" data-id="element-722">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-723">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-724">
            Tu Transformación Semana a Semana
          </h2>
          <p className="text-xl text-brand-muted" data-id="element-725">
            4 semanas estructuradas. Sin adivinar. Solo ejecutar.
          </p>
        </motion.div>

        <div className="relative" data-id="element-726">
          {/* Vertical Line */}
          <div className="absolute left-[15px] md:left-[23px] top-4 bottom-4 w-[2px] bg-gradient-to-b from-brand-cyan via-brand-purple to-brand-gold opacity-30" data-id="element-727" />

          <div className="space-y-12" data-id="element-728">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1
          }} className="relative pl-12 md:pl-16" data-id="element-729">
                {/* Dot */}
                <div className={`absolute left-[11px] md:left-[19px] top-1.5 w-2.5 h-2.5 rounded-full ${step.dot} shadow-[0_0_10px_currentColor]`} data-id="element-730" />

                <div className="bg-brand-card rounded-[20px] p-6 md:p-8 border border-brand-border" data-id="element-731">
                  <span className={`inline-block px-3 py-1 rounded-full text-xs font-bold border mb-4 ${step.color}`} data-id="element-732">
                    {step.badge}
                  </span>
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-733">
                    {step.title}
                  </h3>
                  <p className="text-brand-muted leading-relaxed" data-id="element-734">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-735">
          <p className="text-lg text-white font-medium italic" data-id="element-736">
            "Y esto es solo el MES 1. Los siguientes 60 días los hábitos se
            consolidan exponencialmente."
          </p>
        </motion.div>
      </div>
    </section>;
}